import React from 'react';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import './OutliersToolbar.scss';
import { OutliersSettings } from 'widgets/outliers/components/OutliersSettings';
import OutliersHelp from 'widgets/outliers/components/OutliersHelp';
import ZoomButtons from 'utils/components/Zoom/ZoomButtons';
import SelectionStatus from 'portfolio/components/SelectionStatus';
import { usePortfolioActiveInputUsesOrdersStream } from 'portfolio/store/hooks';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';

export function OutliersToolbar() {
    const { portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();
    const activeInputUsesOrdersStream =
        usePortfolioActiveInputUsesOrdersStream();

    return (
        <WidgetToolbarShowHidePanel mustShow={false}>
            <div className="OutliersToolbar panel-header">
                <div className="toolbar">
                    {!activeInputUsesOrdersStream && (
                        <SelectionStatus
                            selectionRequirements={
                                portfolioSelectionRequirements
                            }
                            widgetName={'Outliers Widget'}
                        />
                    )}
                </div>
                <WidgetToolbar
                    preceedingItems={<OutliersHelp />}
                    fixedItems={
                        activeInputUsesOrdersStream ? (
                            <ZoomButtons />
                        ) : undefined
                    }
                    settingsHeader={`Outlier Settings`}
                    settingsBody={<OutliersSettings />}
                    settingsTriggerText={`Outliers Settings`}
                    settingsClassName="OutliersSettingsModal"
                />
            </div>
        </WidgetToolbarShowHidePanel>
    );
}
